import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import { AudioProvider } from './context/AudioContext';
import useMediaDetection from './hooks/useMediaDetection';

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ErrorBoundary from './components/ErrorBoundary';

// Page Components
import Home from './components/home/Home';
import About from './components/about/About';
import Contact from './components/contact/Contact';
import Gallery from './components/gallery/Gallery';
import Portfolio from './components/portfolio/Portfolio';
import MediaPage from './pages/Media';

// New Page Components (placeholders for now)
import Blog from './components/blog/Blog';
import GloryCommunity from './components/zoom/GloryCommunity';
import Events from './components/events/Events';
import StayConnected from './components/connect/StayConnected';
import Resources from './components/resources/Resources';
import BlogPostEditor from './components/blog/BlogPostEditor';
import Login from './components/auth/Login';
import UnderDevelopment from './components/under-development/UnderDevelopment';
import GivePage from './components/give/GivePage';
import SignalPage from './components/signal/SignalPage';


// Inner App component to use hooks
const AppContent = () => {
  useMediaDetection(); // Hook to detect other media playing
  
  return (
    <div className="App">
      <Header />
      <main>
        <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
            <Route path="/media" element={<ErrorBoundary><MediaPage /></ErrorBoundary>} />
            <Route path="/glory-community" element={<GloryCommunity />} />
          <Route path="/events" element={<Events />} />
          <Route path="/about" element={<About />} />
          <Route path="/stay-connected" element={<StayConnected />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/gallery" element={<Gallery />} />

          
          {/* Legacy routes kept for backward compatibility */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/login" element={<Login />} />
          <Route path="/blog/new" element={<BlogPostEditor />} />
          <Route path="/give" element={<GivePage />} />
          <Route path="/signal" element={<SignalPage />} />
          <Route path="*" element={<UnderDevelopment />} />
        </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AudioProvider>
        <Router>
          <AppContent />
        </Router>
      </AudioProvider>
    </ThemeProvider>
  );
}

export default App;
